exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".board-content table {\n    width: 100%;\n    border: 1px solid black;\n    border-collapse: collapse;\n}\n.board-content th, td {\n    border: 1px solid black;\n    padding: 10px;\n}\n\n.board-title {\n    font-size: 1.5rem;\n}", ""]);

